const FILE_VERSION = 'IndexRouter-v1.21';
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录', requiresAuth: false }
  },
  {
    path: '/mall/decor/live-preview/member',
    name: 'MallMemberLivePreview',
    component: () => import('@/views/mall-fusion/MallMemberLivePreview.vue'),
    meta: { title: '会员中心预览', requiresAuth: false }
  },
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页', icon: 'HomeFilled' }
      },
      {
        path: 'jinglingmao',
        name: 'JinglingMao',
        component: () => import('@/views/jinglingmao/JinglingMao.vue'),
        meta: { title: 'AI精灵猫', icon: 'MagicStick' }
      },
      // AI鏅鸿兘鎺ㄨ崘
      {
        path: 'ai-recommend',
        name: 'AiRecommend',
        component: () => import('@/views/ai/recommend.vue'),
        meta: { title: 'AI智能推荐', icon: 'MagicStick' }
      },
      {
        path: 'ai/selection',
        name: 'AiSelection',
        component: () => import('@/views/ai/selection.vue'),
        meta: { title: 'AI智能选品', icon: 'TrendCharts' }
      },
      {
        path: 'ai/config',
        name: 'AiConfig',
        component: () => import('@/views/ai/config.vue'),
        meta: { title: '推荐配置', icon: 'Setting' }
      },
      {
        path: 'ai/regions',
        name: 'AiRegions',
        component: () => import('@/views/ai/regions.vue'),
        meta: { title: '地区配置', icon: 'Location' }
      },
      {
        path: 'ai/llm-config',
        name: 'LlmConfig',
        component: () => import('@/views/ai/llm-config.vue'),
        meta: { title: 'API配置', icon: 'Cpu' }
      },
      {
        path: 'ai/auto-restock',
        name: 'AiAutoRestock',
        component: () => import('@/views/ai/auto-restock/index.vue'),
        meta: { title: '自动补货', icon: 'Refresh' }
      },
      {
        path: 'ai/ai-image-config',
        name: 'AiImageConfig',
        component: () => import('@/views/ai/AiImageConfig.vue'),
        meta: { title: 'AI生图配置', icon: 'PictureFilled' }
      },
      // 绔炲璋冪爺
      {
        path: 'competitive-research',
        name: 'CompetitiveResearch',
        component: () => import('@/views/competitive/index.vue'),
        meta: { title: '竞对调研', icon: 'DataAnalysis' }
      },
      // 閫夊搧涓婃灦
      {
        path: 'product-select',
        name: 'ProductSelect',
        component: () => import('@/views/product/select-h5.vue'),
        meta: { title: '选品上架', icon: 'Goods' }
      },
      {
        path: 'supply-orders',
        name: 'SupplyOrders',
        component: () => import('@/views/product/supply-orders.vue'),
        meta: { title: '选品清单', icon: 'Document' }
      },
      {
        path: 'inquiry-restock',
        name: 'InquiryRestock',
        component: () => import('@/views/product/inquiry-restock.vue'),
        meta: { title: '询货补品', icon: 'Goods' }
      },
      {
        path: 'quick-assembly',
        name: 'QuickAssembly',
        component: () => import('@/views/product/quick-assembly.vue'),
        meta: { title: '快速组品', icon: 'SetUp' }
      },
      {
        path: 'product/factory-notes',
        name: 'FactoryNotes',
        component: () => import('@/views/product/factory-notes.vue'),
        meta: { title: '厂商管理', icon: 'OfficeBuilding' }
      },
      // 璁㈠崟涓績
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('@/views/order/index.vue'),
        meta: { title: '订单管理', icon: 'ShoppingCart' }
      },
      {
        path: 'order-pool',
        name: 'OrderPool',
        component: () => import('@/views/order/pool.vue'),
        meta: { title: '订单池', icon: 'Box', hidden: true }
      },
      {
        path: 'order-pool-grouped',
        name: 'OrderPoolGrouped',
        component: () => import('@/views/order/pool-grouped.vue'),
        meta: { title: '订单池', icon: 'Box' }
      },
      {
        path: 'my-orders',
        name: 'MyOrders',
        component: () => import('@/views/order/my-orders.vue'),
        meta: { title: '我的工单', icon: 'List' }
      },
      {
        path: 'order-history',
        name: 'OrderHistory',
        component: () => import('@/views/order/history.vue'),
        meta: { title: '发货记录', icon: 'Timer' }
      },
      {
        path: 'tracking-anomalies',
        name: 'TrackingAnomalies',
        component: () => import('@/views/order/tracking-anomalies.vue'),
        meta: { title: '物流异常', icon: 'Warning' }
      },
      {
        path: 'jst-auto-order',
        name: 'JushuiAutoOrder',
        component: () => import('@/views/order/JushuiAutoOrder.vue'),
        meta: { title: '易订助手', icon: 'Promotion' }
      },
      {
        path: 'order/:id',
        name: 'OrderDetail',
        component: () => import('@/views/order/detail.vue'),
        meta: { title: '订单详情', icon: 'Document', hidden: true }
      },
      {
        path: 'order/after-sale',
        name: 'AfterSale',
        component: () => import('@/views/order/after-sale.vue'),
        meta: { title: '售后处理', icon: 'Warning', hidden: true }
      },
      {
        path: 'after-sales',
        name: 'AfterSalesList',
        component: () => import('@/views/order/after-sales-list.vue'),
        meta: { title: '售后管理', icon: 'Warning' }
      },
      {
        path: 'packing-slip',
        name: 'PackingSlip',
        component: () => import('@/views/order/packing-slip.vue'),
        meta: { title: '货单管理', icon: 'Printer' }
      },
      // 璐㈠姟绠＄悊
      {
        path: 'finance',
        name: 'Finance',
        component: () => import('@/views/finance/index.vue'),
        meta: { title: '财务管理', icon: 'Money' }
      },
      {
        path: 'finance/report',
        name: 'FinanceReport',
        component: () => import('@/views/finance/report.vue'),
        meta: { title: '财务报表', icon: 'TrendCharts' }
      },
      {
        path: 'finance/balance',
        name: 'BalanceDashboard',
        component: () => import('@/views/finance/balance.vue'),
        meta: { title: '余额看板', icon: 'Wallet' }
      },
      {
        path: 'finance/tax',
        name: 'TaxManagement',
        component: () => import('@/views/finance/tax-management.vue'),
        meta: { title: '税务管理', icon: 'Notebook' }
      },
      {
        path: 'invoice/out',
        name: 'InvoiceOut',
        component: () => import('@/views/invoice/invoice-out.vue'),
        meta: { title: '销项发票', icon: 'Tickets' }
      },
      {
        path: 'invoice/in',
        name: 'InvoiceIn',
        component: () => import('@/views/finance/invoice-in.vue'),
        meta: { title: '进项发票', icon: 'Tickets' }
      },
      {
        path: 'invoice/gap',
        name: 'InvoiceGap',
        component: () => import('@/views/finance/invoice-gap.vue'),
        meta: { title: '成本票缺口', icon: 'Warning' }
      },
      {
        path: 'offline-payment',
        name: 'OfflinePayment',
        component: () => import('@/views/finance/offline-payment.vue'),
        meta: { title: '线下支付', icon: 'Wallet' }
      },
      {
        path: 'invoice/auto',
        name: 'InvoiceAuto',
        component: () => import('@/views/invoice/invoice-auto.vue'),
        meta: { title: '快速开票', icon: 'MagicStick' }
      },
      // 瀹㈡埛绠＄悊
      {
        path: 'customers',
        name: 'Customers',
        component: () => import('@/views/customer/index.vue'),
        meta: { title: '客户管理', icon: 'User' }
      },
      {
        path: 'sales-dashboard',
        name: 'SalesDashboard',
        component: () => import('@/views/customer/SalesDashboard.vue'),
        meta: { title: '销售看板', icon: 'DataAnalysis' }
      },
      {
        path: 'customer-product-archive',
        name: 'CustomerProductArchive',
        component: () => import('@/views/customer/customer-product-archive.vue'),
        meta: { title: '客品档案', icon: 'Box' }
      },
      {
        path: 'chat',
        name: 'Chat',
        component: () => import('@/views/customer/chat.vue'),
        meta: { title: '商城客服', icon: 'ChatDotRound' }
      },
      {
        path: 'wecom-service',
        name: 'WecomService',
        component: () => import('@/views/customer/wecom-service.vue'),
        meta: { title: '企微客服', icon: 'Service' }
      },
      {
        path: 'wecom-groups',
        name: 'WecomGroups',
        component: () => import('@/views/customer/wecom-groups.vue'),
        meta: { title: '客户群管理', icon: 'ChatDotRound' }
      },
      // 娓犻亾鑾峰
      {
        path: 'acquisition',
        name: 'Acquisition',
        component: () => import('@/views/customer/acquisition.vue'),
        meta: { title: '渠道获客', icon: 'Promotion' }
      },
      // 鍛樺伐绠＄悊
      {
        path: 'employee-info',
        name: 'EmployeeInfo',
        component: () => import('@/views/employee/index.vue'),
        meta: { title: '员工管理', icon: 'UserFilled' }
      },
      {
        path: 'roles',
        name: 'Roles',
        component: () => import('@/views/employee/roles.vue'),
        meta: { title: '角色权限', icon: 'Lock' }
      },
      {
        path: 'work-clock',
        name: 'WorkClock',
        component: () => import('@/views/employee/work-clock.vue'),
        meta: { title: '工作打卡', icon: 'Clock' },
        hidden: true
      },
      {
        path: 'attendance',
        name: 'Attendance',
        component: () => import('@/views/employee/attendance.vue'),
        meta: { title: '考勤管理', icon: 'Calendar' }
      },
      {
        path: 'leave',
        name: 'MonthlyLeave',
        component: () => import('@/views/employee/leave.vue'),
        meta: { title: '假期管理', icon: 'Calendar' }
      },/* 宸插悎骞跺埌鍛樺伐淇℃伅 
      {
        path: 'employee/profile',
        name: 'EmployeeProfile',
        component: () => import('@/views/employee/profile.vue'),
        meta: { title: '员工档案', icon: 'Postcard' }
      }, */
      // 渚挎嵎宸ュ叿
      {
        path: 'tools',
        name: 'Tools',
        component: () => import('@/views/tools/index.vue'),
        meta: { title: '便捷工具', icon: 'Tools' }
      },
      {
        path: 'tools/jinglingmao-product-archive',
        name: 'JinglingmaoProductArchive',
        component: () => import('@/views/tools/components/JinglingmaoProductArchiveTool.vue'),
        meta: { title: '精灵猫建品库', icon: 'Document' }
      },
      {
        path: 'tools/product-qualifications',
        name: 'ProductQualifications',
        component: () => import('@/views/tools/components/ProductQualificationTool.vue'),
        meta: { title: '商品资质库', icon: 'Document' }
      },
      {
        path: 'tools/qnh-migration',
        name: 'QnhMigration',
        component: () => import('@/views/tools/components/QnhMigrationTool.vue'),
        meta: { title: '牵牛花迁移', icon: 'Connection' }
      },
      {
        path: 'smart-model',
        name: 'SmartModel',
        component: () => import('@/views/tools/SmartModel.vue'),
        meta: { title: '数智模型', icon: 'Cpu' }
      },
      {
        path: 'dev-safety',
        name: 'DevSafety',
        component: () => import('@/views/tools/DevSafetyDashboard.vue'),
        meta: { title: '开发安全记录仪', icon: 'Shield' }
      },
      {
        path: 'tools/ai-image',
        name: 'AiImageGen',
        component: () => import('@/views/tools/AiImageGen.vue'),
        meta: { title: 'AI生图', icon: 'PictureFilled' }
      },
      // 浠诲姟绠＄悊
      {
        path: 'tasks',
        name: 'Tasks',
        component: () => import('@/views/tasks/index.vue'),
        meta: { title: '团队工作台', icon: 'DataBoard' }
      },
      {
        path: 'tasks/todo',
        name: 'TasksTodo',
        component: () => import('@/views/tasks/todo.vue'),
        meta: { title: '我的待办', icon: 'Bell' }
      },
      {
        path: 'tasks/created',
        name: 'TasksCreated',
        component: () => import('@/views/tasks/created.vue'),
        meta: { title: '我创建的', icon: 'EditPen' }
      },
      {
        path: 'tasks/my',
        name: 'TasksMy',
        component: () => import('@/views/tasks/my.vue'),
        meta: { title: '我的工作台', icon: 'UserFilled' }
      },
      {
        path: 'tasks/cycle',
        name: 'TasksCycle',
        component: () => import('@/views/tasks/cycle.vue'),
        meta: { title: '循环任务', icon: 'Refresh' }
      },
      {
        path: 'tasks/org',
        name: 'TasksOrg',
        component: () => import('@/views/tasks/org.vue'),
        meta: { title: '组织架构', icon: 'Share' }
      },
      {
        path: 'tasks/team',
        name: 'TasksTeam',
        component: () => import('@/views/tasks/team.vue'),
        meta: { title: '团队工作任务', icon: 'List' }
      },
      {
        path: 'tasks/personal',
        name: 'TasksPersonal',
        component: () => import('@/views/tasks/personal.vue'),
        meta: { title: '个人工作任务', icon: 'User' }
      },
      // 缁╂晥涓績
      {
        path: 'performance',
        name: 'Performance',
        component: () => import('@/views/performance/index.vue'),
        meta: { title: '绩效中心', icon: 'TrendCharts' }
      },
      {
        path: 'order-fulfillment',
        name: 'OrderFulfillment',
        component: () => import('@/views/order/OrderFulfillment.vue'),
        meta: { title: '订单履约', icon: 'Tickets' }
      },
      // 绯荤粺绠＄悊
      {
        path: 'merchant-codes',
        name: 'MerchantCodes',
        component: () => import('@/views/system/merchant-codes.vue'),
        meta: { title: '商户编码库', icon: 'Files' }
      },
      {
        path: 'logs',
        name: 'Logs',
        component: () => import('@/views/system/logs.vue'),
        meta: { title: '操作日志', icon: 'Notebook' }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/system/settings.vue'),
        meta: { title: '系统设置', icon: 'Setting' }
      },
      {
        path: 'ops-center',
        name: 'OpsCenter',
        component: () => import('@/views/system/ops-center.vue'),
        meta: { title: '技术运维', icon: 'Monitor' }
      },
      {
        path: 'mall/goods/list',
        name: 'MallGoodsList',
        component: () => import('@/views/mall-fusion/MallGoodsList.vue'),
        meta: { title: '商品库', icon: 'Goods' }
      },
      {
        path: 'mall/goods/edit',
        name: 'MallGoodsEdit',
        component: () => import('@/views/mall-fusion/MallGoodsEdit.vue'),
        meta: { title: '商品编辑', icon: 'Goods' }
      },
      {
        path: 'mall/goods/category',
        name: 'MallGoodsCategory',
        component: () => import('@/views/mall-fusion/MallCategoryList.vue'),
        meta: { title: '商品分类', icon: 'CollectionTag' }
      },
      {
        path: 'mall/goods/attribute',
        name: 'MallGoodsAttribute',
        component: () => import('@/views/mall-fusion/MallGoodsAttribute.vue'),
        meta: { title: '商品属性', icon: 'Tickets' }
      },
      {
        path: 'mall/goods/comment',
        name: 'MallGoodsComment',
        component: () => import('@/views/mall-fusion/MallGoodsComment.vue'),
        meta: { title: '评价管理', icon: 'ChatDotRound' }
      },
      {
        path: 'mall/goods/service',
        name: 'MallGoodsService',
        component: () => import('@/views/mall-fusion/MallServiceList.vue'),
        meta: { title: '服务保障', icon: 'Service' }
      },
      {
        path: 'mall/goods/stock-warning',
        name: 'MallStockWarning',
        component: () => import('@/views/mall-fusion/MallStockWarning.vue'),
        meta: { title: '库存预警', icon: 'Warning' }
      },
      {
        path: 'mall/goods/stock-log',
        name: 'MallStockLog',
        component: () => import('@/views/mall-fusion/MallStockLog.vue'),
        meta: { title: '补货记录', icon: 'Document' }
      },
      {
        path: 'mall/goods/third-party',
        name: 'MallGoodsThirdParty',
        redirect: '/mall/goods/list',
        meta: { title: '三方产品', icon: 'Connection' }
      },
      {
        path: 'mall/order-center',
        name: 'MallOrderCenter',
        redirect: '/mall/order/list',
        meta: { title: '订单中心' }
      },
      // ====== 鍟嗗煄鍚庡彴鏂拌矾鐢?======
      { path: 'mall/dashboard', name: 'MallDashboard', component: () => import('@/views/mall-fusion/MallDashboard.vue'), meta: { title: '数据总览' } },
      { path: 'mall/order/list', name: 'MallOrderList', component: () => import('@/views/mall-fusion/MallOrderList.vue'), meta: { title: '订单管理' } },
      { path: 'mall/order/after-sale', name: 'MallAfterSale', component: () => import('@/views/mall-fusion/MallAfterSale.vue'), meta: { title: '售后管理' } },
      { path: 'mall/order/invoice', name: 'MallOrderInvoice', component: () => import('@/views/mall-fusion/MallOrderInvoice.vue'), meta: { title: '订单发票' } },
      { path: 'mall/order/recharge', name: 'MallOrderRecharge', component: () => import('@/views/mall-fusion/MallOrderRecharge.vue'), meta: { title: '充值订单' } },
      { path: 'mall/order/proxy', name: 'MallOrderProxy', component: () => import('@/views/mall-fusion/MallOrderProxy.vue'), meta: { title: '代客下单' } },
      { path: 'mall/user/list', name: 'MallUserList', component: () => import('@/views/mall-fusion/MallUserList.vue'), meta: { title: '用户列表' } },
      { path: 'mall/user/level', name: 'MallUserLevel', component: () => import('@/views/mall-fusion/MallUserLevel.vue'), meta: { title: '会员等级' } },
      { path: 'mall/member', redirect: '/mall/user/list', meta: { title: '会员管理' } },
      { path: 'mall/market/coupon', name: 'MallCoupon', component: () => import('@/views/mall-fusion/MallCoupon.vue'), meta: { title: '优惠券' } },
      { path: 'mall/market/activity', name: 'MallActivity', component: () => import('@/views/mall-fusion/MallActivity.vue'), meta: { title: '营销活动' } },
      { path: 'mall/commission/agent', name: 'MallCommAgent', component: () => import('@/views/mall-fusion/MallCommissionAgent.vue'), meta: { title: '分销商' } },
      { path: 'mall/commission/level', name: 'MallCommLevel', component: () => import('@/views/mall-fusion/MallCommissionLevel.vue'), meta: { title: '分销等级' } },
      { path: 'mall/commission/order', name: 'MallCommOrder', component: () => import('@/views/mall-fusion/MallCommissionOrder.vue'), meta: { title: '分销订单' } },
      { path: 'mall/commission/detail', name: 'MallCommDetail', component: () => import('@/views/mall-fusion/MallCommissionReward.vue'), meta: { title: '佣金明细' } },
      { path: 'mall/commission/goods', name: 'MallCommGoods', component: () => import('@/views/mall-fusion/MallCommissionGoods.vue'), meta: { title: '分销商品' } },
      { path: 'mall/withdraw', name: 'MallWithdraw', component: () => import('@/views/mall-fusion/MallWithdraw.vue'), meta: { title: '提现管理' } },
      { path: 'mall/config', name: 'MallConfig', component: () => import('@/views/mall-fusion/MallConfig.vue'), meta: { title: '商城配置' } },
      { path: 'mall/decor/template', name: 'MallDecorTemplate', component: () => import('@/views/mall-fusion/MallDecorTemplate.vue'), meta: { title: '模板管理' } },
      { path: 'mall/decor/page/:id', name: 'MallDecorPage', component: () => import('@/views/mall-fusion/MallDecorPage.vue'), meta: { title: '装修模板' } },
      { path: 'mall/dispatch', name: 'MallDispatch', component: () => import('@/views/mall-fusion/MallDispatch.vue'), meta: { title: '配送设置' } },
      { path: 'mall/chat/faq', name: 'MallChatFaq', component: () => import('@/views/mall-fusion/MallChatQuestion.vue'), meta: { title: '常见问题' } },
      { path: 'mall/chat/words', redirect: '/mall/chat/faq', meta: { title: '常用语' } },
      { path: 'mall/chat/staff', name: 'MallChatStaff', component: () => import('@/views/mall-fusion/MallChatCustomerService.vue'), meta: { title: '客服管理' } },
      { path: 'mall/chat/session', redirect: '/mall/chat/staff', meta: { title: '会话管理' } },
      { path: 'mall/data/fake-user', name: 'MallFakeUser', component: () => import('@/views/mall-fusion/MallFakeUser.vue'), meta: { title: '虚拟用户' } },
      { path: 'mall/data/page-link', name: 'MallPageLink', component: () => import('@/views/mall-fusion/MallPageLink.vue'), meta: { title: '页面链接' } },
      { path: 'mall/data/richtext', name: 'MallRichtext', component: () => import('@/views/mall-fusion/MallRichtext.vue'), meta: { title: '富文本' } },
      { path: 'mall/notification', name: 'MallNotification', component: () => import('@/views/mall-fusion/MallNotification.vue'), meta: { title: '消息配置' } },
      { path: 'mall/wechat/config', name: 'MallWechatConfig', component: () => import('@/views/mall-fusion/MallWechatConfig.vue'), meta: { title: '微信配置' } },
      { path: 'mall/wechat/reply', name: 'MallWechatReply', component: () => import('@/views/mall-fusion/MallWechatReply.vue'), meta: { title: '自动回复' } },
      { path: 'mall/wechat/menu', name: 'MallWechatMenu', component: () => import('@/views/mall-fusion/MallWechatMenu.vue'), meta: { title: '自定义菜单' } },
      { path: 'mall/wechat/material', name: 'MallWechatMaterial', component: () => import('@/views/mall-fusion/MallWechatMaterial.vue'), meta: { title: '素材管理' } },
      // AI閫夊潃妯″潡
      {
        path: 'site/projects',
        name: 'SiteProjects',
        component: () => import('@/views/site/ProjectList.vue'),
        meta: { title: '选址项目', icon: 'MapLocation' }
      },
      {
        path: 'site/project/:id',
        name: 'SiteProjectDetail',
        component: () => import('@/views/site/ProjectDetail.vue'),
        props: true,
        meta: { title: '项目详情', icon: 'MapLocation', hidden: true }
      },
      {
        path: 'site/config',
        name: 'SiteConfig',
        component: () => import('@/views/site/SiteConfig.vue'),
        meta: { title: '选址配置', icon: 'Setting' }
      },
      {
        path: 'site/analysis-report/:projectId/:candidateId',
        name: 'SiteAnalysisReport',
        component: () => import('@/views/site/AnalysisReport.vue'),
        props: true,
        meta: { title: 'AI分析报告', icon: 'DataAnalysis', hidden: true }
      },
      {
        path: 'site/compare/:projectId',
        name: 'SiteCandidateCompare',
        component: () => import('@/views/site/CandidateCompare.vue'),
        props: true,
        meta: { title: '候选点对比', icon: 'OfficeBuilding', hidden: true }
      },
      {
        path: 'site/dashboard/:projectId',
        name: 'SiteScoreDashboard',
        component: () => import('@/views/site/ScoreDashboard.vue'),
        props: true,
        meta: { title: '评分仪表盘', icon: 'DataBoard', hidden: true }
      },
      {
        path: 'site/ai-recommendation/:projectId',
        name: 'SiteAIRecommendation',
        component: () => import('@/views/site/AIRecommendation.vue'),
        props: true,
        meta: { title: 'AI智能推荐', icon: 'MagicStick', hidden: true }
      },
      {
        path: 'site/ranking/:projectId',
        name: 'SiteRanking',
        component: () => import('@/views/site/CandidateRanking.vue'),
        props: true,
        meta: { title: '候选点排行榜', icon: 'Rank', hidden: true }
      },
      // 鏁版櫤杩愯惀
      {
        path: 'ai-ops/product-health',
        name: 'AiOpsProductHealth',
        component: () => import('@/views/ai-ops/ProductHealth.vue'),
        meta: { title: '商品健康', icon: 'FirstAidKit', requiresAiOps: true }
      },
      {
        path: 'ai-ops/price-compare',
        name: 'AiOpsPriceCompare',
        component: () => import('@/views/ai-ops/PriceCompare.vue'),
        meta: { title: '竞对比价', icon: 'PriceTag', requiresAiOps: true }
      },
      {
        path: 'ai-ops/cost-manage',
        name: 'AiOpsCostManage',
        component: () => import('@/views/ai-ops/CostManage.vue'),
        meta: { title: '成本管理', icon: 'Coin', requiresAiOps: true }
      },
      {
        path: 'ai-ops/decision-board',
        name: 'AiOpsDecisionBoard',
        component: () => import('@/views/ai-ops/DecisionBoard.vue'),
        meta: { title: '决策看板', icon: 'DataBoard', requiresAiOps: true }
      },
      {
        path: 'ai-ops/analytics',
        name: 'AiOpsAnalytics',
        component: () => import('@/views/ai-ops/Analytics.vue'),
        meta: { title: '经营分析', icon: 'TrendCharts', requiresAiOps: true }
      },
      {
        path: 'ai-ops/pricing-rules',
        name: 'AiOpsPricingRules',
        component: () => import('@/views/ai-ops/PricingRules.vue'),
        meta: { title: '定价规则', icon: 'PriceTag', requiresAiOps: true }
      },
      {
        path: 'ai-ops/store-config',
        name: 'AiOpsStoreConfig',
        component: () => import('@/views/ai-ops/StoreConfig.vue'),
        meta: { title: '门店配置', icon: 'OfficeBuilding', requiresAiOps: true }
      }
    ]
  },
  // 绉诲姩绔矾鐢憋紙涓嶉渶瑕佺櫥褰曢獙璇侊紝浼氳蛋浼佸井OAuth锛?
  {
    path: '/mobile',
    name: 'MobileHome',
    redirect: '/mobile/acquisition'
  },
  {
    path: '/mobile/acquisition',
    name: 'MobileAcquisition',
    component: () => import('@/views/mobile/acquisition.vue'),
    meta: { title: '获客记录', requiresAuth: false }
  },
  {
    path: '/mobile/login-error',
    name: 'MobileLoginError',
    component: () => import('@/views/mobile/login-error.vue'),
    meta: { title: '登录失败', requiresAuth: false }
  },
  {
    path: '/public/richtext/:id',
    name: 'PublicRichtext',
    component: () => import('@/views/public/RichtextPublic.vue'),
    meta: { title: '协议详情', requiresAuth: false }
  },
  {
    path: '/public/protocol/:type',
    name: 'PublicProtocol',
    component: () => import('@/views/public/RichtextPublic.vue'),
    meta: { title: '协议详情', requiresAuth: false }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/dashboard'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 璺敱瀹堝崼
router.beforeEach((to, from, next) => {
  // 璁剧疆椤甸潰鏍囬
  document.title = to.meta.title ? `${to.meta.title} - SCM工作台` : 'SCM工作台'

  const token = localStorage.getItem('token')

  if (to.meta.requiresAuth === false) {
    next()
  } else if (!token && to.path !== '/login') {
    next('/login')
  } else {
    // 鏁版櫤杩愯惀妯″潡璺敱瀹堝崼: 浠呭厑璁告寚瀹氱敤鎴疯闂?
    if (to.meta.requiresAiOps) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      const allowedIds = [1, 100, 101]
      if (!userInfo.id || !allowedIds.includes(userInfo.id)) {
        next('/dashboard')
        return
      }
    }
    next()
  }
})

export default router
